// Publications archive — books, articles, and chapters.
// Source: VITA 23.docx (verified) + PDFs in /public/articles/ + curated additions.
// Schema fields:
//   pdfUrl:      path to local PDF in /public/articles/ or /public/books/ when available
//   doi:         DOI string (rendered as doi.org link)
//   externalUrl: publisher/catalog URL — rendered only when neither pdfUrl nor doi is present
// Sorted by year descending; within a year, ordered by id.
// No facts invented — fields are null when source metadata is unverified.

export const publications = [
  // === Books ===
  {
    id: "b2",
    type: "book",
    year: 2021,
    title: "Discourse analysis beyond the speech event (2nd ed.)",
    publisher: "Routledge",
    coauthors: "Stanton Wortham & Angela Reyes",
    doi: null,
    pdfUrl: "/books/discourse-analysis.pdf",
    externalUrl: null,
  },
  {
    id: "b1",
    type: "book",
    year: 2020,
    title:
      "Migration narratives: Diverging stories in schools, churches, and civic institutions",
    publisher: "Bloomsbury",
    coauthors:
      "Stanton Wortham, Briana Nichols, Katherine Clonan-Roy & Catherine Rhodes",
    doi: null,
    pdfUrl: "/books/migration.pdf",
    externalUrl: "https://books.google.com/books/about/Migration_Narratives.html?id=VFn5DwAAQBAJ",
  },
  {
    id: "b3",
    type: "book",
    year: 2009,
    title: "Bullish on uncertainty: How organizational cultures transform participants",
    publisher: "Cambridge University Press",
    coauthors: "Alexandra Michel & Stanton Wortham",
    doi: null,
    pdfUrl: null,
    externalUrl: "https://books.google.com/books/about/Bullish_on_Uncertainty.html?id=egttPq1E3ZAC",
  },
  {
    id: "b4",
    type: "book",
    year: 2006,
    title:
      "Learning identity: The joint emergence of academic learning and social identity",
    publisher: "Cambridge University Press",
    coauthors: null,
    doi: null,
    pdfUrl: null,
    externalUrl: "https://www.cambridge.org/core/books/learning-identity/98B12AB9C943FBE397D4950270A1E4D8",
  },
  {
    id: "b5",
    type: "book",
    year: 2001,
    title: "Narratives in action: A strategy for research and analysis",
    publisher: "Teachers College Press",
    coauthors: null,
    doi: null,
    pdfUrl: null,
    externalUrl: "https://archive.org/details/narrativesinacti0000wort",
  },
  {
    id: "b6",
    type: "book",
    year: 1994,
    title: "Acting out participant examples in the classroom",
    publisher: "John Benjamins",
    coauthors: null,
    doi: null,
    pdfUrl: null,
    externalUrl: "https://benjamins.com/catalog/pbns.30",
  },

  // === Articles & chapters (year descending) ===

  // 2026
  {
    id: "a54",
    type: "article",
    year: 2026,
    title: "Faculty engagement patterns in online formative or whole person education: Characteristics of highly engaged faculty",
    journal: "Innovative Higher Education",
    volume: null,
    pages: null,
    coauthors: "Katrina Borowiec, Stanton Wortham, Deoksoon Kim & Elizabeth Barsotti",
    doi: null,
    pdfUrl: null,
    externalUrl: "https://link.springer.com/article/10.1007/s10755-025-09802-3",
  },
  // 2024
  {
    id: "a55",
    type: "article",
    year: 2024,
    title: "Resonant education",
    journal: "Educational Theory",
    volume: "74",
    pages: "963–967",
    coauthors: "Stanton Wortham",
    doi: "10.1111/edth.12683",
    pdfUrl: null,
    externalUrl: null,
  },
  {
    id: "a56",
    type: "article",
    year: 2024,
    title: "Can Korea have academic achievement plus well-being? The case of Hyukshin schools",
    journal: "Journal of Educational Change",
    volume: "25",
    pages: "393–415",
    coauthors: "Stanton Wortham, Clara Shim, Deoksoon Kim & Dennis Shirley",
    doi: "10.1007/s10833-023-09497-3",
    pdfUrl: null,
    externalUrl: null,
  },
  {
    id: "a16",
    type: "article",
    year: 2024,
    title: "Voices from the industry: How EdTech leaders responded to the COVID-19 pandemic",
    journal: "ECNU Review of Education",
    volume: "7",
    pages: "420–441",
    coauthors: "Deoksoon Kim, Katrina Borowiec, Drina Kei Yatsu & Stanton Wortham",
    doi: "10.1177/20965311241237239",
    pdfUrl: "/articles/voices-from-the-industry.pdf",
    externalUrl: null,
  },

  // 2023
  {
    id: "a17",
    type: "article",
    year: 2023,
    title: "Measuring faculty engagement in online formative or whole-person education: A revised instrument and item response theory model",
    journal: "Online Learning",
    volume: "27",
    pages: "93–121",
    coauthors: "Stanton Wortham, Katrina Borowiec & Deoksoon Kim",
    doi: "10.24059/olj.v27i4.4033",
    pdfUrl: "/articles/measuring-faculty-engagement.pdf",
    externalUrl: null,
  },

  // 2022
  {
    id: "a1",
    type: "article",
    year: 2022,
    title: "Turning friends into objects: A letter struggling with analytic distance in the New Latino Diaspora",
    journal: "Qualitative Psychology",
    volume: "9",
    pages: "329–335",
    coauthors: null,
    doi: "10.1037/qup0000220",
    pdfUrl: "/articles/turning-friends-into-objects.pdf",
    externalUrl: null,
  },
  {
    id: "a48",
    type: "article",
    year: 2022,
    title: "Narrating heterogeneous identities in multilingual communities",
    journal: "Multilingualism and identity: Interdisciplinary perspectives (Cambridge), Ayres-Bennett & Fisher (Eds.)",
    volume: null,
    pages: "239–257",
    coauthors: "Sabina Perrino & Stanton Wortham",
    doi: null,
    pdfUrl: null,
    externalUrl: "https://www.cambridge.org/core/books/multilingualism-and-identity/7986F8AC4CF1007F9233206335080734",
  },

  // 2021
  {
    id: "a2",
    type: "article",
    year: 2021,
    title:
      "Formative education online: Teaching the whole person during the global COVID-19 pandemic",
    journal: "AERA Open",
    volume: "7",
    pages: "1–12",
    coauthors:
      "Deoksoon Kim, Stanton Wortham, Katrina Borowiec, Drina Kei Yatsu, Samantha Ha, Stephanie Carroll, Lizhou Wang & Julie Kim",
    doi: "10.1177/23328584211015229",
    pdfUrl: null,
    externalUrl: null,
  },
  {
    id: "a3",
    type: "article",
    year: 2021,
    title: "Wholeness as a developmental goal",
    journal: "Mind, Culture & Activity",
    volume: "28",
    pages: "254–267",
    coauthors: "Stanton Wortham, Samantha Ha & Jeremy Alexander",
    doi: "10.1080/10749039.2021.1961157",
    pdfUrl: "/articles/wholeness-as-a-developmental-goal.pdf",
    externalUrl: null,
  },
  {
    id: "a4",
    type: "article",
    year: 2021,
    title: "Making language 'academic:' Language ideologies, enregisterment, and ontogenesis",
    journal: "Language and Education",
    volume: "35",
    pages: "522–538",
    coauthors: "Catherine Rhodes, Katherine Clonan-Roy & Stanton Wortham",
    doi: "10.1080/09500782.2020.1797771",
    pdfUrl: null,
    externalUrl: null,
  },
  {
    id: "a18",
    type: "article",
    year: 2021,
    title: "Supporting holistic student development through online community building",
    journal: "Online Learning",
    volume: "25",
    pages: "145–155",
    coauthors: "Katrina Borowiec, Deoksoon Kim, Lizhou Wang, Julie Kim & Stanton Wortham",
    doi: "10.24059/olj.v25i4.2882",
    pdfUrl: "/articles/supporting-holistic-student-development.pdf",
    externalUrl: null,
  },

  // 2020
  {
    id: "a5",
    type: "article",
    year: 2020,
    title: "Educating for comprehensive well-being",
    journal: "ECNU Review of Education",
    volume: "3",
    pages: "406–436",
    coauthors:
      "Stanton Wortham, Renata Love Jones, William Peters, Stacy Morris & Juan Cristóbal García-Huidobro",
    doi: null,
    pdfUrl: null,
    externalUrl: null,
  },
  {
    id: "a19",
    type: "article",
    year: 2020,
    title: "The quest for a purpose to encompass the highest moral values: Introduction to the special issue",
    journal: "ECNU Review of Education",
    volume: "3",
    pages: "399–405",
    coauthors: "Dennis Shirley, Stanton Wortham & Deoksoon Kim",
    doi: "10.1177/2096531120938388",
    pdfUrl: "/articles/quest-for-a-purpose.pdf",
    externalUrl: null,
  },

  // 2018
  {
    id: "a6",
    type: "article",
    year: 2018,
    title:
      "Black flight: Heterogeneous accounts of Mexican immigration in a diverse community",
    journal: "Language & Communication",
    volume: "59",
    pages: "4–16",
    coauthors: "Briana Nichols & Stanton Wortham",
    doi: null,
    pdfUrl: "/articles/black-flight-heterogeneous-accounts.pdf",
    externalUrl: null,
  },
  {
    id: "a49",
    type: "article",
    year: 2018,
    title: "Linguistic anthropology of education",
    journal: "The International Encyclopedia of Anthropology (Wiley), Callan (Ed.)",
    volume: null,
    pages: "83–97",
    coauthors: "Stanton Wortham & Sabina Perrino",
    doi: null,
    pdfUrl: null,
    externalUrl: "https://onlinelibrary.wiley.com/page/book/10.1002/9781118924396/homepage/editorscontributors.html",
  },

  // 2017
  {
    id: "a7",
    type: "article",
    year: 2017,
    title:
      "The production of schoolchildren as Enlightenment subjects",
    journal: "American Educational Research Journal",
    volume: "54",
    pages: "834–867",
    coauthors: "Holly Link, Sarah Gallo & Stanton Wortham",
    doi: "10.3102/0002831217706926",
    pdfUrl: "/articles/production-of-schoolchildren-as-enlightenment-subjects.pdf",
    externalUrl: null,
  },
  {
    id: "a20",
    type: "article",
    year: 2017,
    title: "Discourse analysis across events",
    journal: "Encyclopedia of Language and Education (Springer)",
    volume: null,
    pages: "71–83",
    coauthors: "Angela Reyes & Stanton Wortham",
    doi: "10.1007/978-3-319-02243-7_7",
    pdfUrl: "/articles/discourse-analysis-across-events.pdf",
    externalUrl: null,
  },
  {
    id: "a21",
    type: "article",
    year: 2017,
    title: "Introduction to volume \"Discourse and Education\"",
    journal: "Encyclopedia of Education, Vol. 3 (Springer), Wortham, Kim & May (Eds.)",
    volume: null,
    pages: "ix–xxi",
    coauthors: "Stanton Wortham & Deoksoon Kim",
    doi: null,
    pdfUrl: "/articles/introduction-to-discourse-and-education.pdf",
    externalUrl: null,
  },

  // 2016
  {
    id: "a22",
    type: "article",
    year: 2016,
    title: "Shifting racial stereotypes in late adolescence: Heterogeneous resources for developmental change in the New Latino Diaspora",
    journal: "Language & Communication",
    volume: "46",
    pages: "51–61",
    coauthors: "Katherine Clonan-Roy, Stanton Wortham & Briana Nichols",
    doi: "10.1016/j.langcom.2015.10.003",
    pdfUrl: "/articles/shifting-racial-stereotypes.pdf",
    externalUrl: null,
  },

  // 2015
  {
    id: "a23",
    type: "article",
    year: 2015,
    title: "Moral panic about sexual promiscuity: Heterogeneous scales in the identification of one middle-school Latina girl",
    journal: "Linguistics and Education",
    volume: null,
    pages: null,
    coauthors: "Katherine Clonan-Roy, Catherine R. Rhodes & Stanton Wortham",
    doi: "10.1016/j.linged.2015.08.005",
    pdfUrl: "/articles/moral-panic-about-sexual-promiscuity.pdf",
    externalUrl: null,
  },
  {
    id: "a24",
    type: "article",
    year: 2015,
    title: "Narratives across speech events",
    journal: "The Handbook of Narrative Analysis (Wiley-Blackwell), De Fina & Georgakopoulou (Eds.)",
    volume: null,
    pages: "160–177",
    coauthors: "Stanton Wortham & Catherine R. Rhodes",
    doi: null,
    pdfUrl: "/articles/narratives-across-speech-events.pdf",
    externalUrl: null,
  },
  {
    id: "a50",
    type: "article",
    year: 2015,
    title: "Promoting listening by augmenting uncertainty",
    journal: "Listening to teach: Beyond didactic pedagogy (SUNY Press), Waks (Ed.)",
    volume: null,
    pages: "167–182",
    coauthors: "Stanton Wortham & Alexandra Michel",
    doi: null,
    pdfUrl: null,
    externalUrl: "https://www.abebooks.com/9781438458328/Listening-Teach-Beyond-Didactic-Pedagogy-1438458320/plp",
  },
  {
    id: "a51",
    type: "article",
    year: 2015,
    title: "Increasing \"parent involvement\" in the New Latino Diaspora",
    journal: "Revisiting education in the New Latino Diaspora (Information Age Publishing), Hamann, Wortham & Murillo (Eds.)",
    volume: null,
    pages: "263–281",
    coauthors: "Sarah Gallo, Stanton Wortham & Ian Bennett",
    doi: null,
    pdfUrl: null,
    externalUrl: "https://www.infoagepub.com/products/Revisiting-Education-in-the-New-Latino-Diaspora",
  },
  {
    id: "a52",
    type: "article",
    year: 2015,
    title: "Heterogeneity in the New Latino Diaspora",
    journal: "Revisiting education in the New Latino Diaspora (Information Age Publishing), Hamann, Wortham & Murillo (Eds.)",
    volume: null,
    pages: "171–181",
    coauthors: "Stanton Wortham & Catherine Rhodes",
    doi: null,
    pdfUrl: null,
    externalUrl: "https://www.infoagepub.com/products/Revisiting-Education-in-the-New-Latino-Diaspora",
  },

  // 2014
  {
    id: "a25",
    type: "article",
    year: 2014,
    title: "Conflicting ideologies of Mexican immigrant English across levels of schooling",
    journal: "International Multilingual Research Journal",
    volume: "8",
    pages: "124–140",
    coauthors: "Sarah Gallo, Holly Link, Elaine Allard, Stanton Wortham & Katherine Mortimer",
    doi: "10.1080/19313152.2013.825563",
    pdfUrl: "/articles/conflicting-ideologies-of-mexican-immigrant-english.pdf",
    externalUrl: null,
  },
  {
    id: "a26",
    type: "article",
    year: 2014,
    title: "Immigrant Spanish as liability or asset? Generational diversity in language ideologies at school",
    journal: "Journal of Language, Identity & Education",
    volume: "13",
    pages: "335–353",
    coauthors: "Elaine Allard, Katherine Mortimer, Sarah Gallo, Holly Link & Stanton Wortham",
    doi: null,
    pdfUrl: "/articles/immigrant-spanish-as-liability.pdf",
    externalUrl: null,
  },
  {
    id: "a27",
    type: "article",
    year: 2014,
    title: "The right ingredients: Essential if you want to bake the cake right!",
    journal: "Anesthesiology",
    volume: "120",
    pages: "22–23",
    coauthors: "Stanton Wortham, Aditee P. Ambardekar & Alan Jay Schwartz",
    doi: null,
    pdfUrl: "/articles/the-right-ingredients.pdf",
    externalUrl: null,
  },
  {
    id: "a53",
    type: "article",
    year: 2014,
    title: "\"gusame ka'lata!\": Faux Spanish in the New Latino Diaspora",
    journal: "Heteroglossia as Practice and Pedagogy (Springer), Creese & Blackledge (Eds.)",
    volume: null,
    pages: "255–273",
    coauthors: "Holly Link, Sarah Gallo & Stanton Wortham",
    doi: null,
    pdfUrl: null,
    externalUrl: "https://link.springer.com/chapter/10.1007/978-94-007-7856-6_14",
  },

  // 2013
  {
    id: "a28",
    type: "article",
    year: 2013,
    title: "Pre-teen literacy and subsequent teenage childbearing in a US population",
    journal: "Contraception",
    volume: "87",
    pages: "459–464",
    coauthors: "Ian M. Bennett, Rosemary Frasso, Scarlett Bellamy, Stanton Wortham & Kennen Gross",
    doi: "10.1016/j.contraception.2012.08.020",
    pdfUrl: "/articles/pre-teen-literacy.pdf",
    externalUrl: null,
  },
  {
    id: "a29",
    type: "article",
    year: 2013,
    title: "Scattered challenges, singular solutions: The new Latino diaspora",
    journal: "Phi Delta Kappan",
    volume: null,
    pages: null,
    coauthors: "Stanton Wortham, Katherine Clonan-Roy, Holly Link & Carlos Martínez",
    doi: null,
    pdfUrl: "/articles/scattered-challenges-singular-solutions.pdf",
    externalUrl: null,
  },
  {
    id: "a30",
    type: "article",
    year: 2013,
    title: "Life as a chord: Heterogeneous resources in the social identification of one migrant girl",
    journal: "Applied Linguistics",
    volume: "34",
    pages: "536–553",
    coauthors: "Stanton Wortham & Catherine R. Rhodes",
    doi: null,
    pdfUrl: "/articles/life-as-a-chord.pdf",
    externalUrl: null,
  },
  {
    id: "a31",
    type: "article",
    year: 2013,
    title: "The sophistication of human resources: The learning leader's challenge",
    journal: "EFMD Global Focus",
    volume: "7",
    pages: null,
    coauthors: "Annie McKee & Stanton Wortham",
    doi: null,
    pdfUrl: "/articles/sophistication-of-human-resources.pdf",
    externalUrl: null,
  },

  // 2012
  {
    id: "a13",
    type: "article",
    year: 2012,
    title: "Beyond macro and micro in the linguistic anthropology of education",
    journal: "Anthropology & Education Quarterly",
    volume: "43",
    pages: null,
    coauthors: null,
    doi: null,
    pdfUrl: null,
    externalUrl: null,
  },
  {
    id: "a32",
    type: "article",
    year: 2012,
    title: "The production of relevant scales: Social identification of migrants during rapid demographic change in one American town",
    journal: "Applied Linguistics Review",
    volume: "3",
    pages: "75–99",
    coauthors: "Stanton Wortham & Catherine R. Rhodes",
    doi: null,
    pdfUrl: "/articles/production-of-relevant-scales.pdf",
    externalUrl: null,
  },
  {
    id: "a33",
    type: "article",
    year: 2012,
    title: "Sobresalir: Latino parent perspectives on New Latino Diaspora schools",
    journal: "International Journal of Multicultural Education",
    volume: "14",
    pages: null,
    coauthors: "Sarah Gallo & Stanton Wortham",
    doi: null,
    pdfUrl: "/articles/latino-parent-perspectives.pdf",
    externalUrl: null,
  },
  {
    id: "a34",
    type: "article",
    year: 2012,
    title: "Relational education: Applying Gergen's work to educational research and practice",
    journal: "Psychological Studies",
    volume: "57",
    pages: "164–171",
    coauthors: "Stanton Wortham & Kara Jackson",
    doi: null,
    pdfUrl: "/articles/relational-education.pdf",
    externalUrl: null,
  },

  // 2011
  {
    id: "a14",
    type: "article",
    year: 2011,
    title: "Interviews as interactional data",
    journal: "Language in Society",
    volume: "40",
    pages: "39–50",
    coauthors: "Stanton Wortham, Katherine Mortimer, Kathleen Lee, Elaine Allard & Kathleen White",
    doi: null,
    pdfUrl: "/articles/interviews-as-interactional-data.pdf",
    externalUrl: null,
  },
  {
    id: "a35",
    type: "article",
    year: 2011,
    title: "Homies in the New Latino Diaspora",
    journal: "Language & Communication",
    volume: "31",
    pages: "191–202",
    coauthors: "Stanton Wortham, Katherine Mortimer & Elaine Allard",
    doi: "10.1016/j.langcom.2011.02.007",
    pdfUrl: "/articles/homies-in-the-new-latino-diaspora.pdf",
    externalUrl: null,
  },
  {
    id: "a36",
    type: "article",
    year: 2011,
    title: "Racialization in payday mugging narratives",
    journal: "Journal of Linguistic Anthropology",
    volume: "21",
    pages: "E56–E75",
    coauthors: "Stanton Wortham, Elaine Allard, Kathy Lee & Katherine Mortimer",
    doi: "10.1111/j.1548-1395.2011.01097.x",
    pdfUrl: "/articles/racialization-in-payday-mugging.pdf",
    externalUrl: null,
  },
  {
    id: "a37",
    type: "article",
    year: 2011,
    title: "What does philosophy have to offer education, and who should be offering it?",
    journal: "Educational Theory",
    volume: "61",
    pages: null,
    coauthors: null,
    doi: null,
    pdfUrl: "/articles/what-does-philosophy.pdf",
    externalUrl: null,
  },
  {
    id: "a38",
    type: "article",
    year: 2011,
    title: "Concepts and methods for using narrative in teacher education",
    journal: "University of Pennsylvania ScholarlyCommons",
    volume: null,
    pages: null,
    coauthors: "Betsy R. Rymes & Stanton Wortham",
    doi: null,
    pdfUrl: "/articles/concepts-and-methods-for-using-narrative.pdf",
    externalUrl: null,
  },
  {
    id: "a39",
    type: "article",
    year: 2011,
    title: "Wondering about dialogic theory and practice",
    journal: "Journal of Russian & East European Psychology",
    volume: "49",
    pages: "71–76",
    coauthors: null,
    doi: null,
    pdfUrl: "/articles/wondering-about-dialogic-theory.pdf",
    externalUrl: null,
  },

  // 2010
  {
    id: "a15",
    type: "article",
    year: 2010,
    title: "Teacher identity in the context of literacy teaching: Three explorations of classroom positioning and interaction in secondary schools",
    journal: "Teaching and Teacher Education",
    volume: "26",
    pages: "234–243",
    coauthors: "Leigh A. Hall, Amy Suzanne Johnson, Mary M. Juzwik, Stanton Wortham & Melissa Mosley",
    doi: null,
    pdfUrl: "/articles/teacher-identity-in-the-context-of-literacy-teaching.pdf",
    externalUrl: null,
  },
  {
    id: "a40",
    type: "article",
    year: 2010,
    title: "Helping immigrants identify as \"university-bound students\": Unexpected difficulties in teaching the hidden curriculum",
    journal: "Revista de Educación",
    volume: "353",
    pages: "107–128",
    coauthors: "Katherine Mortimer, Stanton Wortham & Elaine Allard",
    doi: null,
    pdfUrl: "/articles/helping-immigrants-identify.pdf",
    externalUrl: null,
  },
  {
    id: "a41",
    type: "article",
    year: 2010,
    title: "Redefining the gap between theory and practice: Should anthropologists try to change the world?",
    journal: "Anthropology News",
    volume: null,
    pages: null,
    coauthors: null,
    doi: null,
    pdfUrl: "/articles/redefining-the-gap.pdf",
    externalUrl: null,
  },

  // 2009
  {
    id: "a42",
    type: "article",
    year: 2009,
    title: "Mexicans as model minorities in the New Latino Diaspora",
    journal: "Anthropology & Education Quarterly",
    volume: "40",
    pages: "388–404",
    coauthors: "Stanton Wortham, Katherine Mortimer & Elaine Allard",
    doi: null,
    pdfUrl: "/articles/mexicans-as-model-minorities.pdf",
    externalUrl: null,
  },

  // 2008
  {
    id: "a12",
    type: "article",
    year: 2008,
    title: "Linguistic anthropology of education",
    journal: "Annual Review of Anthropology",
    volume: "37",
    pages: "37–51",
    coauthors: null,
    doi: null,
    pdfUrl: "/articles/linguistic-anthropology-of-education.pdf",
    externalUrl: null,
  },
  {
    id: "a43",
    type: "article",
    year: 2008,
    title: "The objectification of identity across events",
    journal: "Linguistics and Education",
    volume: "19",
    pages: "294–311",
    coauthors: null,
    doi: "10.1016/j.linged.2008.05.010",
    pdfUrl: "/articles/objectification-of-identity-across-events.pdf",
    externalUrl: null,
  },
  {
    id: "a44",
    type: "article",
    year: 2008,
    title: "Linguistic anthropology",
    journal: "The Handbook of Educational Linguistics (Blackwell), Spolsky & Hult (Eds.)",
    volume: null,
    pages: "83–97",
    coauthors: null,
    doi: null,
    pdfUrl: "/articles/linguistic-anthropology-handbook.pdf",
    externalUrl: null,
  },
  {
    id: "a45",
    type: "article",
    year: 2008,
    title: "Shifting identities in the classroom",
    journal: "Identity Trouble: Critical Discourse and Contested Identities (Springer)",
    volume: null,
    pages: "205–228",
    coauthors: null,
    doi: null,
    pdfUrl: "/articles/shifting-identities-in-the-classroom.pdf",
    externalUrl: null,
  },
  {
    id: "a46",
    type: "article",
    year: 2008,
    title: "Educational constructionisms",
    journal: "Handbook of Constructionist Research (Guilford), Holstein & Gubrium (Eds.)",
    volume: null,
    pages: "107–127",
    coauthors: "Stanton Wortham & Kara Jackson",
    doi: null,
    pdfUrl: "/articles/educational-constructionisms.pdf",
    externalUrl: null,
  },

  // 2007
  {
    id: "a47",
    type: "article",
    year: 2007,
    title: "Listening beyond the self: How organizations create direct involvement",
    journal: "Learning Inquiry",
    volume: "1",
    pages: "89–97",
    coauthors: "Alexandra Michel & Stanton Wortham",
    doi: "10.1007/s11519-007-0016-y",
    pdfUrl: "/articles/listening-beyond-the-self.pdf",
    externalUrl: null,
  },

  // 2005
  {
    id: "a8",
    type: "article",
    year: 2005,
    title: "Socialization beyond the speech event",
    journal: "Journal of Linguistic Anthropology",
    volume: "15",
    pages: "95–112",
    coauthors: null,
    doi: null,
    pdfUrl: null,
    externalUrl: null,
  },

  // 2004
  {
    id: "a9",
    type: "article",
    year: 2004,
    title: "The interdependence of social identification and learning",
    journal: "American Educational Research Journal",
    volume: "41",
    pages: "715–750",
    coauthors: null,
    doi: null,
    pdfUrl: null,
    externalUrl: null,
  },
  {
    id: "a10",
    type: "article",
    year: 2004,
    title: "From good student to outcast: The emergence of a classroom identity",
    journal: "Ethos",
    volume: "32",
    pages: "164–187",
    coauthors: null,
    doi: null,
    pdfUrl: null,
    externalUrl: null,
  },

  // 2000
  {
    id: "a11",
    type: "article",
    year: 2000,
    title: "Interactional positioning and narrative self-construction",
    journal: "Narrative Inquiry",
    volume: "10",
    pages: "157–184",
    coauthors: null,
    doi: null,
    pdfUrl: null,
    externalUrl: null,
  },
];
